import { EARTHQUAKE } from "../../actions/portal/";

export default function(state = {}, action){
  switch (action.type) {
    case EARTHQUAKE:
    return action.payload;
    default:
  }

  return state;
}
